import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=7aa30a52&"
import script from "./PackageSummary.vue?vue&type=script&lang=js&"
export * from "./PackageSummary.vue?vue&type=script&lang=js&"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports